import { ModalOverlay, Modal as AriaModal, Dialog } from "react-aria-components"
// @ts-ignore - Can't resolve module for some reason
import styles from "./BottomDrawer.module.css"

const BottomDrawer = ({
  isOpen,
  setIsOpen,
  children,
}: {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  children: React.ReactNode
}) => {
  return (
    <ModalOverlay
      className="tt-modal-overlay items-end"
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      isDismissable
    >
      <AriaModal
        className={`${styles.myModal} tt-modal !rounded-bl-none !rounded-br-none`}
      >
        <Dialog
          className="tt-modal-dialog flex flex-col !h-auto !max-h-[calc(var(--visual-viewport-height)-100px)]"
          data-size="full"
        >
          {children}
        </Dialog>
      </AriaModal>
    </ModalOverlay>
  )
}

export default BottomDrawer
